'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _links = require('../utils/links');

// These are the only links that can be used with url params to control
// redirecting and intent operations.

// example:
// ?intent=salesNotifications

exports.default = {
  // all sales default
  crm: _links.salesDefault,
  salesCalling: _links.salesDefault,
  salesContactProfile: _links.salesDefault,
  salesEmailScheduling: _links.salesDefault,
  salesEmailTracking: _links.salesDefault,
  salesFree: _links.salesDefault,
  salesOutlook: _links.salesDefault,
  salesO365: _links.salesO365,
  salesVsto: _links.salesVsto,

  service: _links.serviceDashboard,

  academySalesSoftwareCert: _links.academySalesSoftwareCert,
  academyAttractingWithFbLesson: _links.academyAttractingWithFbLesson,
  salesDashboard: _links.salesDashboard,
  marketingFree: _links.marketingFree,
  marketingFreeContacts: _links.marketingFreeContacts,
  marketingFreeLeadFlows: _links.marketingFreeLeadFlows,
  marketingFreeForms: _links.marketingFreeForms,
  marketingFreeEmail: _links.marketingFreeEmail,
  marketingAds: _links.marketingAds,
  fbCrm: _links.fbCrm,
  growthhubInbound: _links.growthhubInbound,
  crmContacts: _links.crmContacts,
  crmCompanies: _links.crmCompanies,
  crmDeals: _links.crmDeals,
  crmTasks: _links.crmTasks,
  conversations: _links.conversations,
  salesNotifications: _links.salesNotifications,
  salesTemplates: _links.salesTemplates,
  salesSequences: _links.salesSequences,
  salesDocuments: _links.salesDocuments,
  salesProspects: _links.salesProspects,
  salesMeetings: _links.salesMeetings,
  salesPro: _links.salesPro,
  codeFunnelAnatomy: _links.codeFunnelAnatomy,
  codeFunnelData: _links.codeFunnelData,
  codeFunnelExcel: _links.codeFunnelExcel,
  codeFunnelSeo: _links.codeFunnelSeo,
  codeFunnelInfographics: _links.codeFunnelInfographics,
  codeFunnelTemplates: _links.codeFunnelTemplates,
  leadAds: _links.leadAds,
  learningCenter: _links.learningCenter,
  academyLesson: _links.learningCenter,
  academyTrack: _links.learningCenter,
  connectIntegration: _links.connectIntegration,
  purchase: _links.purchase,
  trial: _links.trial
};
module.exports = exports['default'];